/* AQUON Instagram Feed.

   The cards are already on screen from Liquid before this file runs. All this
   does is (a) drive play/mute for the section's own videos and (b), when a
   token is configured, swap fresh Instagram media into those same cards.

   No layout shift: .aqrp__card carries a fixed aspect-ratio, so replacing the
   media inside it cannot change the card box. If the request fails for any
   reason the server-rendered fallback is simply left alone. */
(function () {
  'use strict';

  var FIELDS = 'id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,username';
  var ENDPOINT = 'https://graph.instagram.com/me/media';

  if (window.AquonInstagramFeed) return;
  var instances = new Map();
  window.AquonInstagramFeed = { init: boot };

  // Each video owns its pause choice, including after it leaves the viewport.
  function bindVideos(root, signal) {
    var states = new Map();
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplay = root.dataset.autoplay === 'true';
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = states.get(entry.target);
        if (!state) return;
        state.visible = entry.intersectionRatio >= 0.55;
        reconcile(state);
      });
    }, { threshold: [0, 0.55, 1] }) : null;

    function listen(target, type, fn) { target.addEventListener(type, fn, { signal: signal }); }
    function allowed(state) {
      return !signal.aborted && !state.disposed && !document.hidden && state.visible &&
        !state.userPaused && !state.blocked && (state.manual || (autoplay && !motion.matches));
    }
    function sync(state) {
      if (state.disposed || signal.aborted || state.card.querySelector('.aqrp__video') !== state.video) return;
      var playing = !state.video.paused && !state.video.ended;
      var label = state.card.dataset.videoLabel || '';
      state.card.classList.toggle('is-playing', playing);
      state.card.classList.toggle('is-unmuted', !state.video.muted);
      var toggle = state.card.querySelector('[data-aqig-toggle]');
      if (toggle) toggle.setAttribute('aria-label', (playing ? 'Pause video' : 'Play video') + (label ? ': ' + label : ''));
      var playIcon = state.card.querySelector('[data-aqig-play-icon]');
      var pauseIcon = state.card.querySelector('[data-aqig-pause-icon]');
      if (playIcon) playIcon.toggleAttribute('hidden', playing);
      if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
      var mute = state.card.querySelector('[data-aqig-mute]');
      if (mute) {
        mute.setAttribute('aria-label', state.video.muted ? 'Unmute video' : 'Mute video');
        mute.setAttribute('aria-pressed', String(!state.video.muted));
      }
    }
    function pause(state) {
      if (!state.video.paused) { state.expectedPause = true; state.video.pause(); }
      sync(state);
    }
    function play(state) {
      if (state.pending || !state.video.paused) return;
      // Off-screen cards have no active source, so preload heuristics cannot
      // compete with the first visible image. Manual play uses the same path.
      var hydrated = false;
      state.video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
        hydrated = true;
      });
      if (state.video.hasAttribute('data-src')) {
        state.video.src = state.video.getAttribute('data-src');
        state.video.removeAttribute('data-src');
        hydrated = true;
      }
      if (hydrated) {
        state.video.removeAttribute('data-aqig-deferred');
        state.video.load();
      }
      state.pending = true;
      var result;
      try { result = state.video.play(); } catch (err) { result = Promise.reject(err); }
      Promise.resolve(result).then(function () {
        state.pending = false;
        // Playback can resolve after a user pause, tab hide, refresh or unload.
        if (!allowed(state)) pause(state); else sync(state);
      }, function () {
        state.pending = false;
        state.blocked = true;
        if (!signal.aborted && !state.disposed) sync(state);
      });
    }
    function reconcile(state) { if (allowed(state)) play(state); else pause(state); }
    function scan() {
      states.forEach(function (state, video) {
        if (!root.contains(video)) {
          state.disposed = true;
          if (observer) observer.unobserve(video);
          pause(state); states.delete(video);
        }
      });
      root.querySelectorAll('[data-aqig-card]').forEach(function (card) {
        var video = card.querySelector('.aqrp__video');
        card.querySelectorAll('[data-aqig-toggle], [data-aqig-mute]').forEach(function (button) { button.hidden = !video; });
        if (!video || states.has(video)) return;
        var state = { video: video, card: card, visible: !observer, userPaused: false, manual: false, blocked: false, pending: false, expectedPause: false };
        states.set(video, state);
        listen(video, 'play', function () {
          if (!state.pending) { state.manual = true; state.userPaused = false; }
          sync(state);
        });
        listen(video, 'pause', function () {
          if (!state.expectedPause) { state.userPaused = true; state.manual = false; }
          state.expectedPause = false;
          sync(state);
        });
        listen(video, 'volumechange', function () { sync(state); });
        listen(video, 'ended', function () { state.userPaused = true; state.manual = false; sync(state); });
        sync(state);
        if (observer) observer.observe(video); else reconcile(state);
      });
    }
    listen(root, 'click', function (event) {
      var button = event.target.closest('[data-aqig-toggle], [data-aqig-mute]');
      if (!button || !root.contains(button)) return;
      var card = button.closest('[data-aqig-card]');
      var state = card && states.get(card.querySelector('.aqrp__video'));
      if (!state) return;
      event.preventDefault();
      // Real People also delegates legacy mute classes at document level.
      event.stopPropagation();
      if (button.hasAttribute('data-aqig-mute')) {
        if (state.video.muted) document.querySelectorAll('.aqrp__video').forEach(function (other) { if (other !== state.video) other.muted = true; });
        state.video.muted = !state.video.muted;
        sync(state);
      } else if (state.video.paused && !state.pending) {
        state.userPaused = false; state.manual = true; state.blocked = false; state.visible = true;
        play(state);
      } else {
        state.userPaused = true; state.manual = false;
        pause(state);
      }
    });
    listen(document, 'visibilitychange', function () { states.forEach(reconcile); });
    listen(motion, 'change', function () {
      states.forEach(function (state) { if (motion.matches) state.manual = false; reconcile(state); });
    });
    signal.addEventListener('abort', function () {
      if (observer) observer.disconnect();
      states.forEach(function (state) { state.disposed = true; pause(state); });
      states.clear();
    }, { once: true });
    scan();
    return scan;
  }

  /* ---------- live refresh ---------- */
  function buildImage(item) {
    var img = document.createElement('img');
    img.className = 'aqrp__poster-img';
    img.src = item.media_type === 'VIDEO' ? (item.thumbnail_url || item.media_url) : item.media_url;
    img.alt = item.caption ? String(item.caption).slice(0, 120) : 'Instagram post';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    return img;
  }

  function buildVideo(item, autoplay) {
    var video = document.createElement('video');
    video.className = 'aqrp__video';
    video.setAttribute('data-src', item.media_url);
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'none';
    if (item.thumbnail_url) video.poster = item.thumbnail_url;
    if (autoplay) {
      video.loop = true;
      video.muted = true;
      video.setAttribute('muted', '');
    } else {
      video.controls = true;
    }
    return video;
  }

  function applyItem(card, item, opts) {
    var poster = card.querySelector('[data-aqig-poster]');
    var slot = card.querySelector('[data-aqig-video-slot]');
    var link = card.querySelector('[data-aqig-link]');
    var caption = card.querySelector('[data-aqig-caption]');
    var user = card.querySelector('[data-aqig-user]');

    if (poster) {
      poster.innerHTML = '';
      poster.appendChild(buildImage(item));
    }

    if (slot) {
      slot.innerHTML = '';
      var isVideo = item.media_type === 'VIDEO';
      if (isVideo) slot.appendChild(buildVideo(item, opts.autoplay));
      card.querySelectorAll('[data-aqig-toggle], [data-aqig-mute]').forEach(function (button) { button.hidden = !isVideo; });
    }

    if (link && item.permalink) {
      link.href = item.permalink;
      link.setAttribute(
        'aria-label',
        (item.caption ? String(item.caption).slice(0, 90) : 'Instagram post') + ' — open on Instagram'
      );
    }
    if (item.caption) card.dataset.videoLabel = String(item.caption).slice(0, 60);
    if (caption && item.caption) caption.textContent = item.caption;
    if (user && item.username) user.textContent = '@' + String(item.username).replace(/^@/, '');
  }

  function refresh(root, signal, scan) {
    var token = root.dataset.token;
    if (!token) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-aqig-card]'));
    if (!cards.length) return;

    var count = parseInt(root.dataset.count, 10) || cards.length;
    var url = ENDPOINT + '?fields=' + encodeURIComponent(FIELDS) +
              '&limit=' + encodeURIComponent(count) +
              '&access_token=' + encodeURIComponent(token);

    var controller = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 8000);

    signal.addEventListener('abort', function () { clearTimeout(timer); if (controller) controller.abort(); }, { once: true });
    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (res) {
        if (!res.ok) throw new Error('Instagram responded ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        clearTimeout(timer);
        var items = (payload && payload.data) || [];
        if (signal.aborted || !items.length) return; // keep the fallback

        root.classList.add('is-refreshing');
        var opts = { autoplay: root.dataset.autoplay === 'true' };

        // Only fill cards we actually have; never add or remove cards, so the
        // row length (and therefore the layout) is fixed by the merchant.
        cards.forEach(function (card, i) {
          if (items[i]) applyItem(card, items[i], opts);
        });

        root.classList.remove('is-refreshing');
        scan();
      })
      .catch(function (err) {
        clearTimeout(timer);
        // Deliberately quiet in production: the fallback is already correct, so
        // a failed refresh is not a user-facing error. Surfaced in the editor
        // so the merchant can see why nothing changed.
        if (!signal.aborted && window.Shopify && window.Shopify.designMode) {
          console.warn('[AQUON Instagram] live refresh skipped:', err && err.message);
        }
      });
  }

  function init(root) {
    if (instances.has(root)) return;
    var controller = new AbortController();
    instances.set(root, controller);
    root.dataset.aqigReady = '1';
    var scan = bindVideos(root, controller.signal);
    if (root.dataset.live === 'true') refresh(root, controller.signal, scan);
  }
  function boot(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-aqig]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (controller, root) {
      if (event.target.contains(root)) { controller.abort(); instances.delete(root); delete root.dataset.aqigReady; }
    });
  });
})();
